import { JSX, splitProps } from "solid-js"

export type ButtonProps = {
	content: string
	disabled?: boolean
	onClick?: JSX.CustomEventHandlersCamelCase<HTMLButtonElement>["onClick"]
	colorway?: "primary" | "neutral"
	type?: "button" | "submit"
	width?: "wide" | "full" | "auto"
}

export function Button(props: ButtonProps) {
	const styles = (() => {
		let classes = ""
		switch (props.colorway ?? "primary") {
			case "primary":
				classes = "border border-primary-content p-2 bg-primary filter brightness-95 cursor-pointer text-primary-content"
				break
			case "neutral":
				classes = "bg-neutral underline cursor-pointer text-neutral-content"
				break
			default:
				classes = ""
		}

		switch (props.width ?? "auto") {
			case "wide":
				classes = classes + " max-w-[15em] min-w-[15em] w-[15em]"
				break
			case "full":
				classes = classes + " w-full"
		}

		return classes
	})()

	return (
		<button disabled={props.disabled} {...(props.onClick ? { onClick: props.onClick } : {})} class={styles} type={props.type ?? "button"}>
			{props.content.toUpperCase()}
		</button>
	)
}
